var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuggestMessagesFalkonAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.603,
    height: 27.068,
    viewBox: "0 0 27.603 27.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161395",
    "data-name": "Group 161395",
    transform: "translate(-864 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161394",
    "data-name": "Group 161394",
    transform: "translate(665 412)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 24,
    height: 24,
    transform: "translate(199 12)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160760",
    "data-name": "Group 160760",
    transform: "translate(-57.971 -52.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M9.107,6.177a13.557,13.557,0,0,1-7.1,7.094.552.552,0,0,0,0,1.014,13.526,13.526,0,0,1,7.076,7.039.581.581,0,0,0,1.068,0,13.551,13.551,0,0,1,7.075-7.039.551.551,0,0,0,0-1.013,13.559,13.559,0,0,1-7.1-7.1.556.556,0,0,0-1.022,0Z",
    transform: "translate(255.959 62.361)",
    fill: "none",
    stroke: "#4c03ae",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M145.049,4.307a6.809,6.809,0,0,1-2.855,2.855.548.548,0,0,0,0,.967,6.785,6.785,0,0,1,2.854,2.854.549.549,0,0,0,.968,0,6.8,6.8,0,0,1,2.854-2.854.548.548,0,0,0,0-.967,6.822,6.822,0,0,1-2.855-2.855.548.548,0,0,0-.967,0Z",
    transform: "translate(131.151 63.982)",
    fill: "none",
    stroke: "#4c03ae",
    strokeWidth: 1.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-arrow-58",
    d: "M11.435,15.435,19.6,9.646,11.435,4V6.485S1.946,8.594,0,17.068c4.143-4.436,11.435-4.262,11.435-4.262Z",
    transform: "translate(872 434)",
    fill: "#4c03ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestMessagesFalkonAiIcon);
export default __webpack_public_path__ + "static/media/suggest-messages-falkon-ai-icon.54a817caad432f0021f7ee147359ac33.svg";
export { ForwardRef as ReactComponent };